var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgAddSelect = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 2.53125C4.52083 1.01042 6.35417 0.25 8.5 0.25C10.6458 0.25 12.4688 1.01042 13.9688 2.53125C15.4896 4.03125 16.25 5.85417 16.25 8C16.25 10.1458 15.4896 11.9792 13.9688 13.5C12.4688 15 10.6458 15.75 8.5 15.75C6.35417 15.75 4.52083 15 3 13.5C1.5 11.9792 0.75 10.1458 0.75 8C0.75 5.85417 1.5 4.03125 3 2.53125ZM13 8.875V7.125C13 6.875 12.875 6.75 12.625 6.75H9.75V3.875C9.75 3.625 9.625 3.5 9.375 3.5H7.625C7.375 3.5 7.25 3.625 7.25 3.875V6.75H4.375C4.125 6.75 4 6.875 4 7.125V8.875C4 9.125 4.125 9.25 4.375 9.25H7.25V12.125C7.25 12.375 7.375 12.5 7.625 12.5H9.375C9.625 12.5 9.75 12.375 9.75 12.125V9.25H12.625C12.875 9.25 13 9.125 13 8.875Z",
    fill: "#333333"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAddSelect, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "1642699981952/static/media/add_select.b907a0e4.svg";
export { ForwardRef as ReactComponent };